export enum StatisticalAnalysisTemporalFilterEnum {
    DAYS = 'DAYS',
    HOURS = 'HOURS',
    MINUTES = 'MINUTES'
}

export interface StatisticalAnalysisTemporalFilterOptions {
    id: StatisticalAnalysisTemporalFilterEnum,
    text: string
}

export interface StatisticalAnalysisTemporalFilterState {
    externalLoading: boolean
    selected: StatisticalAnalysisTemporalFilterOptions
    options: StatisticalAnalysisTemporalFilterOptions[]
}
export const initialStatisticalAnalysisTemporalFilterState =
    (): StatisticalAnalysisTemporalFilterState => ({
        externalLoading: false,
        selected: {
            id: StatisticalAnalysisTemporalFilterEnum.DAYS,
            text: 'statisticalAnalysis.times.days'
        },
        options: [
            {
                id: StatisticalAnalysisTemporalFilterEnum.DAYS,
                text: 'statisticalAnalysis.times.days'
            },
            {
                id: StatisticalAnalysisTemporalFilterEnum.HOURS,
                text: 'statisticalAnalysis.times.hours'
            },
            {
                id: StatisticalAnalysisTemporalFilterEnum.MINUTES,
                text: 'statisticalAnalysis.times.minutes'
            }
        ]
    })
